module.exports = __webpack_public_path__ + "img/image33.61354aa4.jpg";